import { useQuery } from "@tanstack/react-query";
import { SplitContentDynamicTemplateConfig } from "../splitContentTypes";
import { bindDataSourceToTemplate } from "@/pages/template/utils/templateUtils";
import { TemplatePreview } from "@/pages/template/shared/TemplatePreview";
import { DynamicTemplateDataSourceResponseItem } from "@/pages/content/contentTypes";

interface Props {
  config: SplitContentDynamicTemplateConfig;
}

export const SplitContentConfigRendererDynamicTemplate: React.FC<Props> = ({ config }) => {
  const { dataSourceUrl, pollingIntervalSeconds, templateCanvasData } = config;

  const { data: dataSourceResponse } = useQuery({
    queryKey: ["dataSourceUrl", dataSourceUrl],
    queryFn: () => fetch(dataSourceUrl).then((res) => res.json()) as Promise<DynamicTemplateDataSourceResponseItem[]>,
    refetchInterval: pollingIntervalSeconds * 1000,
  });

  const templateWithDataSource = bindDataSourceToTemplate(
    // @ts-ignore
    {
      canvas_data: JSON.parse(templateCanvasData),
    },
    dataSourceResponse ?? []
  );

  if (!templateCanvasData || !templateWithDataSource) {
    return <div>Template not exist anymore?</div>;
  }

  return <TemplatePreview data={templateWithDataSource.canvas_data} previewSize="full" />;
};
